const REDIRECT_BASE = 'https://redirect.invalid';

function hasControlOrBackslash(value: string): boolean {
  for (let i = 0; i < value.length; i++) {
    const code = value.charCodeAt(i);
    if (code <= 0x1f || code === 0x7f || value[i] === '\\') {
      return true;
    }
  }
  return false;
}

/**
 * Return a same-origin path, or null when the value could navigate off-site.
 * Protocol-relative URLs (`//evil.com`), backslashes, and dot-segments that
 * normalize to a leading `//` are rejected. The returned value is the
 * normalized path, not the raw input.
 */
export function safeInternalPath(value: unknown): string | null {
  if (typeof value !== 'string' || value.length === 0) {
    return null;
  }
  if (value[0] !== '/' || value.startsWith('//') || value.startsWith('/\\')) {
    return null;
  }
  if (hasControlOrBackslash(value)) {
    return null;
  }

  let url: URL;
  try {
    url = new URL(value, REDIRECT_BASE);
  } catch {
    return null;
  }
  if (url.origin !== REDIRECT_BASE) {
    return null;
  }

  const path = `${url.pathname}${url.search}${url.hash}`;
  if (path[0] !== '/' || path.startsWith('//') || path.includes('\\')) {
    return null;
  }
  return path;
}
